<template>
  <div class="body-div">
    <!--    top main selection menu-->

    <div class="report-calendar">
      <div class="selecting-options">
        <div class="tiers-btns dropdown selection-user-bar">
          <button
            class="tiers-btn loader-icon"
            data-toggle="dropdown"
            type="button"
            @click="clickOnDateButton"
          >
            <span v-if="loaderIcon">
              <img class="loader-icon" src="img/icons/date-spinner.svg" />
            </span>
            <p v-if="formatDate(statsDate[0]) !== formatDate(statsDate[1])">
              {{ formatDate(statsDate[0]) }}{{ "-"
              }}{{ formatDate(statsDate[1]) }}
            </p>

            <p v-else>
              {{ formatDate(statsDate[0]) }}
            </p>
          </button>
        </div>

        <div
          class="tiers-btns dropdown selection-user-bar"
          v-if="CheckUserPermission([1, 2, 3, 4, 12])"
        >
          <button class="tiers-btn" data-toggle="dropdown" type="button">
            <p>
              {{ selectedLeadFilter }}
              <i class="fas fa-bars" aria-hidden="true"></i>
            </p>
          </button>
          <ul class="dropdown-menu ul-tiers">
            <li
              v-for="btn in LeadFiltersOptions"
              :key="btn.id"
              @click="selectLeadFilter(btn.alias)"
              :class="{ activedrop: selectedLeadFilter === btn.alias }"
            >
              <a>
                {{ btn.name }}
              </a>
            </li>
          </ul>
        </div>

        <div
          class="tiers-btns dropdown selection-user-bar"
          v-if="CheckUserPermission([1, 2, 3, 4, 12])"
        >
          <button class="tiers-btn" data-toggle="dropdown" type="button">
            <p>
              {{ selectedAvg }} <i class="fas fa-bars" aria-hidden="true"></i>
            </p>
          </button>
          <ul class="dropdown-menu ul-tiers">
            <li
              v-for="btn in avgOptions"
              :key="btn.id"
              @click="selectAvg(btn)"
              :class="{ activedrop: selectedAvgRange === btn.alias }"
            >
              <a>
                {{ btn.name }}
              </a>
            </li>
          </ul>
        </div>

        <div
          class="tiers-btns dropdown selection-user-bar"
          v-if="CheckUserPermission([1, 2, 3, 4, 12])"
        >
          <button data-toggle="dropdown" type="button" class="tiers-btn">
            <p>
              {{ selectedTier }} <i class="fas fa-bars" aria-hidden="true"></i>
            </p>
          </button>
          <ul class="dropdown-menu ul-tiers">
            <li
              v-for="btn in tierOptions"
              :key="btn.id"
              @click="selectTier(btn)"
              :class="{ activedrop: selectedTierOption === btn.alias }"
            >
              <a>
                {{ btn.name }}
              </a>
            </li>
          </ul>
        </div>

        <div
          class="tiers-btns dropdown selection-user-bar"
          v-if="CheckUserPermission([1, 2, 3, 4, 12])"
        >
          <button class="tiers-btn" type="button" data-toggle="dropdown">
            <p v-if="selectedUser !== null">
              {{ displayUser }} <i class="fas fa-bars" aria-hidden="true"></i>
            </p>
            <p v-else>
              {{ "ALL USERS" }}<i class="fas fa-bars" aria-hidden="true"></i>
            </p>
          </button>
          <ul class="dropdown-menu ul-users">
            <li
              @click="
                selectedUser = null;
                fetchMainChartData();
              "
              :class="{ activedrop: selectedUser === null }"
            >
              <a>ALL</a>
            </li>
            <li
              v-for="user in usersList"
              :key="user.id"
              :class="{ activedrop: selectedUser === user.id }"
              @click="
                selectedUser = user.id;
                displayUser = user.full_name;
                fetchMainChartData();
              "
            >
              <a>
                {{ user.full_name }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!--    end main selection menu-->

    <div class="main-chart">
      <canvas id="live-stats-main-chart" width="1"></canvas>
    </div>
  </div>
</template>

<script>
import apiClientCreator from "@/helpers/api/request";
import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import moment from "moment";
import { mapState } from "vuex";
//import DatePicker from "vue2-datepicker";
import UsersPermissionCheck from "@/mixins/user/auth/UsersPermissionCheck";
import UsersActiveScope from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/mixins/UsersActiveScope";
import UsersStatsActiveScope from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/mixins/UsersStatsActiveScope";

const mainChartOptions = {
  type: "bar",
  options: {
    layout: {
      padding: {
        top: 26
      }
    },
    plugins: {
      datalabels: {
        align: "end",
        anchor: "end",
        offset: -5,
        /*     backgroundColor: function (context) {
                           return context.dataset.backgroundColor;
                         },*/
        font: {
          family: "Montserrat"
        },
        fontSize: 9,
        // display: function(context) {
        //   let index = context.dataIndex;
        //   let value = context.dataset.data[index];
        //   return value > 0; // display labels with a value greater than 0
        // },
        color: function(context) {
          return context.dataset.borderColor;
        },
        formatter: function(value, index) {
          value = value.toString();
          value = value.split(".").join("");
          value = parseInt(value);
          return value === 0 ? "" : value;
        }
      }
    },

    maintainAspectRatio: false,
    gradientColors: [
      "rgba(29,140,248,0.7)",
      "rgba(29,140,248,0.0)",
      "rgba(29,140,248,0)"
    ],
    gradientStops: [1, 0.4, 0],
    responsive: true,
    scales: {
      yAxes: [
        {
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
          },
          ticks: {
            beginAtZero: true,
            //display:false,
            padding: 0,
            fontColor: "transparent", //"#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 1
          }
        }
      ],
      xAxes: [
        {
          id: "bar-x-axis1",
          // barPercentage: 1.0,
          // categoryPercentage: 0.5,
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "transparent"
          },
          ticks: {
            padding: 0,
            fontColor: "#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 6
          }
        }
      ]
    },
    legend: {
      display: false
    },
    hover: {
      onHover: function(e) {
        const point = this.getElementAtEvent(e);
        if (point.length) e.target.style.cursor = "pointer";
        else e.target.style.cursor = "default";
      }
    },
    tooltips: {
      enabled: true,
      mode: "single",
      callbacks: {
        label: (value, index, values) => {
          value = value.value.toString();
          value = value.split(".").join("");
          value = parseInt(value);

          return ["Count:" + value];
        }
      }
    }
  }
};
Chart.Tooltip.positioners.custom = function(elements, position) {
  if (!elements.length) {
    return false;
  }
  let offset = 0;
  //adjust the offset left or right depending on the event position
  if (elements[0]._chart.width / 2 > position.x) {
    offset = 20;
  } else {
    offset = -20;
  }
  return {
    x: position.x + offset,
    y: 0
  };
};
export default {
  name: "GeneralLiveStatsChart.component.component",
  components: {
    //DatePicker
  },
  mixins: [UsersActiveScope, UsersStatsActiveScope, UsersPermissionCheck],
  props: {
    selectedTab: {
      type: String
    }
  },
  data() {
    return {
      announcement: false,
      mainChartOptions: {
        type: "bar",
        options: {
          layout: {
            padding: {
              top: 26
            }
          },
          plugins: {
            datalabels: {
              align: function(value) {
                if (value.datasetIndex === 0) {
                  return "end";
                }
                if (value.dataset.data[value.dataIndex] > 0) {
                  return "end";
                } else {
                  return "start";
                }
              },
              anchor: function(value) {
                if (value.datasetIndex === 0) {
                  return "end";
                }
                if (value.dataset.data[value.dataIndex] > 0) {
                  return "end";
                } else {
                  return "start";
                }
              },
              offset: -4,
              /*     backgroundColor: function (context) {
                               return context.dataset.backgroundColor;
                             },*/
              font: {
                family: "Arial",
                size: 11
              },

              // display: function(context) {
              //   let index = context.dataIndex;
              //   let value = context.dataset.data[index];
              //   return value > 0; // display labels with a value greater than 0
              // },
              color: function(context) {
                if (context.datasetIndex === 0) {
                  return context.dataset.borderColor;
                } else {
                  return "#000";
                }
              },
              formatter: (value, index) => {
                if (index.datasetIndex === 1) {
                  return value === 0 ? "" : this.avgRawStats[index.dataIndex];
                }
                if (index.datasetIndex === 2) {
                  return "";
                }
                value = value.toString();
                value = value.split(".").join("");
                value = parseInt(value);
                if(value>this.avgRawStats[index.dataIndex]) this.updateLeftChart(value,index)
                return value === 0
                  ? ""
                  : value > this.avgRawStats[index.dataIndex]
                  ? value + " !"
                  : value;
              }
            }
          },

          maintainAspectRatio: false,
          gradientColors: [
            "rgba(29,140,248,0.7)",
            "rgba(29,140,248,0.0)",
            "rgba(29,140,248,0)"
          ],
          gradientStops: [1, 0.4, 0],
          responsive: true,
          scales: {
            yAxes: [
              {
                stacked: true,
                gridLines: {
                  drawBorder: false,
                  color: "transparent",
                  zeroLineColor: "rgba(70,204,253,0)" //"rgba(70,204,253,0.22)",
                },
                ticks: {
                  beginAtZero: true,
                  // display:false,
                  padding: 0,
                  fontColor: "transparent", //"#44A2D2",
                  fontFamily: "Montserrat",
                  fontSize: 8
                }
              }
            ],
            xAxes: [
              {
                minBarLength: 10,
                stacked: true,
                id: "bar-x-axis1",
                // barPercentage: 1.0,
                // categoryPercentage: 0.5,
                gridLines: {
                  drawBorder: false,
                  color: "transparent",
                  zeroLineColor: "rgba(70,204,253,0)"
                },
                ticks: {
                  padding: 0,
                  fontSize: 9
                }
              }
            ]
          },
          legend: {
            display: false
          },
          hover: {
            onHover: function(e) {
              const point = this.getElementAtEvent(e);
              if (point.length) e.target.style.cursor = "pointer";
              else e.target.style.cursor = "default";
            }
          },
          tooltips: {
            position: "custom",
            enabled: true,
            mode: "single",
            fontSize: 6,
            callbacks: {
              label: (value, index, values) => {
                if (value.datasetIndex === 0) {
                  let vals = value.value.toString();
                  vals = vals.split(".").join("");
                  vals = parseInt(vals);

                  let data = ["Count:" + vals];
                  let label = value.label.toLowerCase();
                  if (this.CheckUserPermission([1, 2, 3, 4, 12])) {
                    if (label === "na") {
                      if (this.expendedChartData[label]) {
                        data = this.formatExpendedDataForNa(data, label);
                      } else {
                        this.getExpendData(label);
                      }
                    }
                    if (label === "dp"){
                      let depLabel = "dep";
                      if (this.expendedChartData[depLabel]) {
                        data = this.formatExpendedDataForDep(data, depLabel);
                      } else {
                        this.getExpendData(depLabel);
                      }
                    }
                    if (label.includes("reg")) {
                      let depLabel = "reg";
                      if (this.expendedChartData[depLabel]) {
                        data = this.formatExpendedDataForReg(data, depLabel);
                      } else {
                        this.getExpendData(depLabel);
                      }
                    }
                    if (label.includes("ca")) {
                      let depLabel = "ca";
                      if (this.expendedChartData[depLabel]) {
                        data = this.formatExpendedDataForCa(data, depLabel);
                      } else {
                        this.getExpendData(depLabel);
                      }
                    }
                    if (label === "tr-lv" || label === "tr-on") {
                      let depLabel = label;
                      if (this.expendedChartData[depLabel]) {
                        data = this.formatExpendedDataForTr(data, depLabel);
                      } else {
                        this.getExpendData(depLabel);
                      }
                    }
                    if (
                      label === "bn" ||
                      label === "ni" ||
                      label === "ended" ||
                      label === "rf" ||
                      label === "ld"
                    ) {
                      let depLabel = label;
                      if (this.expendedChartData[depLabel]) {
                        data = this.formatExpendedDataForGroup(data, depLabel);
                      } else {
                        this.getExpendData(depLabel);
                      }
                    }
                  }

                  return data;
                } else {
                  let msg;
                  let msg_wke;
                  let vals = value.value.toString();
                  vals = vals.split(".").join("");
                  vals = parseInt(vals);
                  //TODO;
                  if (vals > 0) {
                    this.announcement = vals;
                    msg = vals + " Below the AVG";
                  } else {
                    msg = vals + " Above the AVG";
                  }
                  let idx = value.index;
                  let wke_val = index.datasets[0].data[idx];
                  let wke_avg_val = this.avgWeekendsRawStats[idx];
                  let conc = wke_avg_val - wke_val;

                  if (conc > 0) {
                    msg_wke = conc + " Below the AVG With Weekends";
                  } else {
                    msg_wke = conc + " Above the AVG With Weekends";
                  }
                  return [msg, msg_wke];
                }
              }
            }
          }
        }
      },

      reqMainChartData: false,

      liveMode: false,
      loaderIcon: false,
      mainChartData: [],

      mainChartTabBuild: null,

      chartTimeOut: null,
      lastUpdate: null,

      statsDate: [moment().toDate(), moment().toDate()],
      usersList: [],
      selectedUser: null,
      tierOptions: [
        {
          id: 1,
          name: "ALL TIERS",
          alias: null
        },
        {
          id: 2,
          name: "TIER1",
          alias: "1"
        },
        {
          id: 3,
          name: "TIER2",
          alias: "2"
        },
        {
          id: 4,
          name: "TIER3",
          alias: "3"
        },
        {
          id: 5,
          name: "TIER4",
          alias: "4"
        }
      ],
      avgOptions: [
        {
          id: 1,
          name: "AVG 7",
          alias: 7
        },
        {
          id: 2,
          name: "AVG 30",
          alias: 30
        },
        {
          id: 3,
          name: "AVG 90",
          alias: 90
        },
        {
          id: 4,
          name: "AVG 180",
          alias: 180
        }
      ],
      selectedAvgRange: 30,
      selectedAvg: "AVG 30",
      selectedTierOption: null,
      expendedChartData: {},
      selectedTier: "ALL TIERS",
      LeadFiltersOptions: [
        {
          id: 1,
          name: "ALL LEADS",
          alias: "ALL"
        },
        {
          id: 2,
          name: "DUP",
          alias: "DUP"
        },
        {
          id: 3,
          name: "REG",
          alias: "REG"
        }
      ],
      selectedLeadFilter: "ALL",
      selectedLeadOption: "ALL LEADS",
      allAvgStats: {},
      allWeekendAvgStats: {},
      avgRawStats: [],
      avgWeekendsRawStats: [],
      chartKeys: [
        ["COST", [1, 2]],
        ["REG", [1, 2, 3, 4, 5, 12]],
        ["NEW", [1, 2, 3, 4, 5, 12]],
        ["NR", [1, 2, 3, 4, 5, 12]],
        ["NI", [1, 2, 3, 4, 5, 12]],
        ["BN", [1, 2, 3, 4, 5, 12]],
        ["NU", [1, 2, 3, 4, 5, 12]],
        ["MERGED", [1, 2, 3, 4, 5, 12]],
        ["ENDED", [1, 2, 3, 4, 5, 12]],
        ["TR-LV", [1, 2, 3, 4, 5, 12]],
        ["TR-ON", [1, 2, 3, 4, 5, 12]],
        ["C2C", [1, 2, 3, 4, 5, 12]],
        ["SMS", [1, 2, 3, 4, 5, 12]],
        ["CA", [1, 2, 3, 4, 5, 12]],
        ["NA", [1, 2, 3, 4, 5, 12]],
        ["RF", [1, 2, 3, 4, 5, 12]],
        ["LD", [1, 2, 3, 4, 5, 12]],
        ["DEP", [1, 2, 3, 4, 5, 12]],
        ["CC-DEC", [1, 2, 3, 4, 5, 12]]
      ]
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", ["updateLiveChart", "salesPersonList"])
  },
  beforeDestroy() {
    this.$root.$off("updateLiveStats");
  },
  mounted() {
    this.usersList = this.FilterStatsNonActiveUsers(
      this.FilterNonActiveUsers()
    );
    this.$root.$on("updateLiveStats", data => {
      this.statsDate = moment().toDate();
      this.fetchMainChartData();
    });

    this.fetchMainChartData();
  },
  watch: {
    updateLiveChart: function() {
      if (this.updateLiveChart) {
        if (this.updateLiveChart.dates) {
          if (!this.updateLiveChart.dates.start) {
            this.updateLiveChart.dates.start = undefined;
          }
          if (!this.updateLiveChart.dates.end) {
            this.updateLiveChart.dates.end = undefined;
          }
          this.statsDate = [
            moment(this.updateLiveChart.dates.start).toDate(),
            moment(this.updateLiveChart.dates.end).toDate()
          ];
        } else {
          this.statsDate = [moment().toDate(), moment().toDate()];
        }
        if (this.updateLiveChart.lead_filter) {
          this.selectedLeadFilter = this.updateLiveChart.lead_filter;
          this.$store.commit(
            "clients/setLiveDataFilter",
            this.selectedLeadFilter
          );
        }
        this.fetchMainChartData();
        this.$store.commit("clients/setUpdateLiveChart", false);
        // if(this.CheckUserPermission([1, 2, 3, 4, 5, 6, 8, 12])){
        //   this.$store.commit('clients/setLiveChartDataToCalendar',{
        //     users:this.usersList,
        //     live_mode:true
        //   })
        // }
      }
    }
  },
  methods: {
    updateLeftChart(value,idx){
    // Task #1060 Logic.
    },
    clickOnDateButton() {
      this.$store.commit("clients/setLiveChartDataToCalendar", true);
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YY");
    },

    formatExpendedDataForNa(data, label) {
      if (this.expendedChartData[label].users.length > 0) {
        let tempArr = [];
        this.expendedChartData[label].users.map(item => {
          tempArr.push(
            item.user + "[" + item.total + "] (" + item.percents + "%)"
          );
        });

        let perChunk = 3; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }

      if (Object.keys(this.expendedChartData[label].camp).length > 0) {
        let camp = this.expendedChartData[label].camp;
        Object.keys(camp).map(item => {
          data.push(
            item + "[" + camp[item].count + "](" + camp[item].percent + ")"
          );
        });
      }

      if (Object.keys(this.expendedChartData[label].tiers).length > 0) {
        let tier = this.expendedChartData[label].tiers;
        let tempTier = [];
        Object.keys(tier).map(item => {
          tempTier.push(item + "-" + tier[item]);
        });
        data.push(tempTier);
      }
      return data;
    },
    formatExpendedDataForDep(data, label) {
      if (this.expendedChartData[label].users.length > 0) {
        let tempArr = [];
        this.expendedChartData[label].users.map(item => {
          tempArr.push(item.user + "(" + item.count + ")");
        });
        let perChunk = 5; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }
      if (Object.keys(this.expendedChartData[label].campaigns).length > 0) {
        let camp = this.expendedChartData[label].campaigns[0];
        let tempArr = [];
        Object.keys(camp).map(item => {
          tempArr.push(item + " ");
          // tempArr.push(item + '(' + camp[item].count +')')
        });
        let perChunk = 5; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }

      if (this.expendedChartData[label].brokers.length > 0) {
        let brokers = this.expendedChartData[label].brokers;
        let tempArr = [];
        brokers.map(item => {
          tempArr.push(item.broker.name + "(" + item.overall_count + ")");
          // tempArr.push(item + '(' + camp[item].count +')')
        });
        let perChunk = 5; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }
      if (Object.keys(this.expendedChartData[label].countries).length > 0) {
        let country = this.expendedChartData[label].countries[0];
        let tempArr = [];
        Object.keys(country).map(item => {
          tempArr.push(item + "(" + country[item].count + ")");
        });
        let perChunk = 5; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }
      if (Object.keys(this.expendedChartData[label].tiers).length > 0) {
        let tier = this.expendedChartData[label].tiers[0];
        let tempArr = [];
        Object.keys(tier).map(item => {
          tempArr.push(item + "(" + tier[item].count + ")");
        });
        let perChunk = 5; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }
      return data;
    },
    formatExpendedDataForReg(data, label) {
      if (Object.keys(this.expendedChartData[label].campaigns).length > 0) {
        let camp = this.expendedChartData[label].campaigns;
        let tempArr = [];
        Object.keys(camp).map(item => {
          tempArr.push(
            item + "[" + camp[item].count + "](" + camp[item].percent + ")"
          );
        });
        let perChunk = 3; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }
      if (Object.keys(this.expendedChartData[label].tiers).length > 0) {
        let tier = this.expendedChartData[label].tiers;
        let tempArr = [];
        Object.keys(tier).map(item => {
          tempArr.push(
            item + "[" + tier[item].count + "](" + tier[item].percents + "%)"
          );
        });
        let perChunk = 3; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }
      return data;
    },
    formatExpendedDataForCa(data, label) {
      if (this.expendedChartData[label].users.length > 0) {
        let tempArr = [];
        this.expendedChartData[label].users.map(item => {
          tempArr.push(
            item.user + "[" + item.total + "](" + item.percents + "%)"
          );
        });
        let perChunk = 5; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }
      if (Object.keys(this.expendedChartData[label].campaigns).length > 0) {
        let camp = this.expendedChartData[label].campaigns;
        let tempArr = [];
        Object.keys(camp).map(item => {
          tempArr.push(
            item + "[" + camp[item].count + "](" + camp[item].percent + ")"
          );
        });
        let perChunk = 5; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }
      if (Object.keys(this.expendedChartData[label].tiers).length > 0) {
        let tier = this.expendedChartData[label].tiers;
        let tempArr = [];
        Object.keys(tier).map(item => {
          tempArr.push(
            item + "[" + tier[item].count + "](" + tier[item].percents + "%)"
          );
        });
        let perChunk = 3; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }
      if (this.expendedChartData[label].reasons.length > 0) {
        let tempArr = [];
        this.expendedChartData[label].reasons.map(item => {
          tempArr.push(
            item.status.type.substring(0, 15) +
              "[" +
              item.count +
              "](" +
              item.percents +
              "%)"
          );
        });
        let perChunk = 1; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }
      return data;
    },
    formatExpendedDataForTr(data, label) {
      if (this.expendedChartData[label].users_to.length > 0) {
        let tempArr = [];
        this.expendedChartData[label].users_to.map(item => {
          tempArr.push(
            "TO " + item.user + "[" + item.total + "](" + item.percents + "%)"
          );
        });
        let perChunk = 5; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }
      if (Object.keys(this.expendedChartData[label].campaigns).length > 0) {
        let camp = this.expendedChartData[label].campaigns;
        let tempArr = [];
        Object.keys(camp).map(item => {
          tempArr.push(
            item + "[" + camp[item].count + "](" + camp[item].percent + ")"
          );
        });
        let perChunk = 5; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }
      if (Object.keys(this.expendedChartData[label].tiers).length > 0) {
        let tier = this.expendedChartData[label].tiers;
        let tempArr = [];
        Object.keys(tier).map(item => {
          tempArr.push(
            item + "[" + tier[item].count + "](" + tier[item].percents + "%)"
          );
        });
        let perChunk = 3; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }
      if (this.expendedChartData[label].users_by.length > 0) {
        let tempArr = [];
        this.expendedChartData[label].users_by.map(item => {
          tempArr.push(
            "BY " + item.user + "[" + item.total + "](" + item.percents + "%)"
          );
        });
        let perChunk = 5; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }
      return data;
    },
    formatExpendedDataForGroup(data, label) {
      if (this.expendedChartData[label].users.length > 0) {
        let tempArr = [];
        this.expendedChartData[label].users.map(item => {
          tempArr.push(
            item.user + "[" + item.total + "](" + item.percents + "%)"
          );
        });
        let perChunk = 5; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }
      if (Object.keys(this.expendedChartData[label].campaigns).length > 0) {
        let camp = this.expendedChartData[label].campaigns;
        let tempArr = [];
        Object.keys(camp).map(item => {
          tempArr.push(
            item + "[" + camp[item].count + "](" + camp[item].percent + ")"
          );
        });
        let perChunk = 5; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }
      if (Object.keys(this.expendedChartData[label].tiers).length > 0) {
        let tier = this.expendedChartData[label].tiers;
        let tempArr = [];
        Object.keys(tier).map(item => {
          tempArr.push(
            item + "[" + tier[item].count + "](" + tier[item].percents + "%)"
          );
        });
        let perChunk = 3; // items per chunk
        let result = this.chunksArray(tempArr, perChunk);
        result.map(arr => {
          data.push(arr);
        });
      }

      return data;
    },

    chunksArray(tempArr, perChunk) {
      let arr = tempArr.reduce((resultArray, item, index) => {
        const chunkIndex = Math.floor(index / perChunk);

        if (!resultArray[chunkIndex]) {
          resultArray[chunkIndex] = []; // start a new chunk
        }

        resultArray[chunkIndex].push(item);

        return resultArray;
      }, []);
      return arr;
    },
    selectLeadFilter(filter) {
      this.selectedLeadFilter = filter;
      this.$store.commit("clients/setLiveDataFilter", this.selectedLeadFilter);
      this.fetchMainChartData();
    },
    selectTier(tier) {
      this.selectedTierOption = tier.alias;
      this.selectedTier = tier.name;
      this.fetchMainChartData();
    },
    selectAvg(avg) {
      this.selectedAvgRange = avg.alias;
      this.selectedAvg = avg.name;
      this.fetchMainChartData();
    },
    FilterNonActiveUsers() {
      return this.salesPersonList.filter(user => user.active !== 0);
    },
    getKeyByValue(object, value) {
      return Object.keys(object).find(key => object[key] === value);
    },
    async fetchMainChartData() {
      this.loaderIcon = true;
      if (this.$router.currentRoute.name === "Main") {
        if (this.chartTimeOut) {
          clearTimeout(this.chartTimeOut);
        }
        this.chartTimeOut = setTimeout(() => {
          clearTimeout(this.chartTimeOut);
          this.chartTimeOut = null;
          this.fetchMainChartData();

          if (this.mainChartTabBuild) {
            this.mainChartTabBuild.destroy();
          }
        }, 15 * 60 * 1000);
        this.$emit("fetchStart");
        this.reqMainChartData = true;
        this.expendedChartData = {};
        let canvasId = "live-stats-main-chart";
        this.mainChartData = [];
        let queryObj = {
          stats_date_at: moment(this.statsDate[0]).format("YYYY-MM-DD"),
          stats_date_to: moment(this.statsDate[1]).format("YYYY-MM-DD")
        };
        if (this.selectedUser) {
          queryObj = { ...queryObj, user_id: this.selectedUser };
        }
        if (this.selectedTierOption) {
          queryObj = { ...queryObj, country_tiers: [this.selectedTierOption] };
        }
        switch (this.selectedLeadFilter) {
          case "ALL":
            delete queryObj.dup_exclude;
            delete queryObj.dup;
            break;
          case "DUP":
            delete queryObj.dup_exclude;
            queryObj.dup = 1;
            break;
          case "REG":
            queryObj.dup_exclude = 1;
            delete queryObj.dup;
            break;
        }

        queryObj = { ...queryObj, avg_count: this.selectedAvgRange };
        queryObj = { ...queryObj, special_req: 1 };
        if (this.mainChartTabBuild) {
          this.mainChartTabBuild.destroy();
        }
        if (
          Object.keys(this.allAvgStats).length === 0 &&
          this.CheckUserPermission([1, 2, 3, 4, 12])
        ) {
          await apiClientCreator(
            `reports/timely_report/average_report/overall/true`
          )
            .get("", {})
            .then(async res => {
              let tempObj = res.data.workdays;
              let weekendsTempObj = res.data.weekends;

              Object.keys(tempObj).map(days => {
                if (
                  Object.keys(tempObj[days]["bad_number_reasons"]).length === 0
                ) {
                  return;
                }
                this.allAvgStats[days] = {
                  BN: tempObj[days]["bad_number_reasons"],
                  DEP: tempObj[days]["deposits"],
                  NA: tempObj[days]["no_answer_agents"],
                  NI: tempObj[days]["not_interested_leads"],
                  NR: tempObj[days]["not_reached"],
                  REG: tempObj[days]["registrations"],
                  CA: tempObj[days]["scheduled_call_status"],
                  "TR-LV": tempObj[days]["transferred_to_live"],
                  "TR-ON": tempObj[days]["transferred_to_online"],
                  DEC: tempObj[days]["cc_decline_deposits"],
                  C2C: tempObj[days]["c2c"],
                  MERGED: tempObj[days]["merged"],
                  SMS: tempObj[days]["sms"],
                  ENDED: tempObj[days]["ended"],
                  NU: tempObj[days]["nu"],
                  LD: tempObj[days]["leads"],
                  RF: tempObj[days]["referrals"]
                };
              });

              Object.keys(weekendsTempObj).map(days => {
                if (
                  Object.keys(weekendsTempObj[days]["bad_number_reasons"])
                    .length === 0
                ) {
                  return;
                }
                this.allWeekendAvgStats[days] = {
                  BN: weekendsTempObj[days]["bad_number_reasons"],
                  DEP: weekendsTempObj[days]["deposits"],
                  NA: weekendsTempObj[days]["no_answer_agents"],
                  NI: weekendsTempObj[days]["not_interested_leads"],
                  NR: weekendsTempObj[days]["not_reached"],
                  REG: weekendsTempObj[days]["registrations"],
                  CA: weekendsTempObj[days]["scheduled_call_status"],
                  "TR-LV": weekendsTempObj[days]["transferred_to_live"],
                  "TR-ON": weekendsTempObj[days]["transferred_to_online"],
                  DEC: weekendsTempObj[days]["cc_decline_deposits"],
                  C2C: weekendsTempObj[days]["c2c"],
                  MERGED: weekendsTempObj[days]["merged"],
                  SMS: weekendsTempObj[days]["sms"],
                  ENDED: weekendsTempObj[days]["ended"],
                  NU: weekendsTempObj[days]["nu"],
                  LD: weekendsTempObj[days]["leads"],
                  RF: weekendsTempObj[days]["referrals"]
                };
              });
            })
            .catch(err => {});
        }
        await apiClientCreator(`client/stats/today_chart`)
          .get("", { params: queryObj })
          .then(async res => {
            this.lastUpdate = moment().format("DD/MM/YY HH:mm");
            this.$emit("setLastUpdate", this.lastUpdate);
            this.mainChartData = res.data;
            if (this.mainChartTabBuild) {
              this.mainChartTabBuild.destroy();
            }
            this.createMainChart(
              this.mainChartData,
              canvasId,
              this.mainChartOptions,
              this.allAvgStats,
              this.allWeekendAvgStats
            );
            this.reqMainChartData = false;
          })
          .catch(err => {
            this.reqMainChartData = false;
          });
      }
      this.loaderIcon = false;
    },
// main chart builder statsAll = this.mainChartData, chartOpt = this.mainChartOptions, AvgStats = this.allAvgStats, AvgWeekendsStats = this.allWeekendAvgStats

    createMainChart(statsAll, canvasId, chartOpt, AvgStats, AvgWeekendsStats) {
      // get 2 types of stats (main the lower, AVG the upper)
      this.$store.commit("clients/setSubGraphData", {
        chartData: this.mainChartData,
        avgData: this.allAvgStats
      });

      let opt = chartOpt.options;
      //stats titles
      let labels = [];
      //all main stats
      let allStats = [];
      // all svg stats
      let allAvgStats = [];
      // copy this.allAvgStats obj to statsAvg variable
      let statsAvg = Object.assign({}, AvgStats);

      let regNum;
      let allWeekendsAvgStats = [];
      let statsWeekendsAvg = Object.assign({}, AvgWeekendsStats);
      let stats = Object.assign({}, statsAll.data);
      let keyDp;
      let statsKeys = Object.keys(stats);
      let regAvg;
      let regAvgWeek;

      statsKeys.map(data => {
        if(data === 'DP'){
          keyDp = data;
        }
      })

      //  if(this.factoryMode){
      //    let stats =Object.assign({},statsAll);
      //    this.chartKeys.forEach(key=>{
      //      labels.push(key[0])
      //      if(key[0] === 'COST'){
      //        if(`${stats['cost']}`.length > 2){
      //          let len = `${stats['cost']}`.length;
      //          let val = stats['cost'];
      //          switch (len){
      //            case 3:
      //              val = ((stats['cost'] / 10).toFixed(1))
      //              break
      //            case 4:
      //              val = (stats['cost'] / 100).toFixed(2);
      //              break
      //            case 5:
      //              val = (stats['cost'] / 1000).toFixed(3);
      //              break
      //          }
      //          allStats.push(val)
      //          return
      //        }
      //      }
      //
      //      let filter = stats['stats'][this.selectedLeadFilter];
      //      let tier;
      //      let path;
      //    if(this.selectedTierOption){
      //      tier = filter[this.selectedTierOption];
      //      path = 'total_in_tier'
      //    }else{
      //      tier = filter['all_tiers'];
      //      path = 'total_in_filter'
      //    }
      //
      //      let preData;
      //
      //    if(this.selectedUser){
      //      preData = tier[path].users[this.selectedUser]
      //    }else{
      //      preData = tier[path]
      //    }
      //
      //      let stat = 0 + preData[key[0]];
      //    if(`${stat}`.length > 2) {
      //        let len = `${stat}`.length;
      //        let val = stat;
      //        switch (len) {
      //          case 3:
      //            val = ((stat / 10).toFixed(1))
      //            break
      //          case 4:
      //            val = (stat / 100).toFixed(2);
      //            break
      //          case 5:
      //            val = (stat / 1000).toFixed(3);
      //            break
      //
      //      }
      //        allStats.push(val)
      //        return
      //      }
      //
      //      allStats.push(stat)
      //
      // })
      //  }else{
      Object.keys(stats).forEach(data => {
        if (data === "Cost" ||  data === "NEW") {
          return;
        }
        if(data !== "REG") {
          labels.push(data);
        }else{
          regNum = stats[data];
        }


        if (`${stats[data]}`.length > 2) {
          let len = `${stats[data]}`.length;
          let val = stats[data];
          switch (len) {
            case 3:
              ///(parseInt(stats[data])<=500 && parseInt(stats[data])>=1 ) ? val = ((stats[data] / 10).toFixed(1)) : val = ((stats[data] / 10).toFixed(2));
              val = (stats[data] / 10).toFixed(1);
              break;
            case 4:
              val = (stats[data] / 100).toFixed(2);
              break;
            case 5:
              val = (stats[data] / 1000).toFixed(3);
              break;
          }
          if(data !== "REG"){
            allStats.push(val);
          }

          return;
        }
        if(data !== "REG"){
          allStats.push(stats[data]);
        }
      });
      // }
      try {
        if (
          Object.keys(statsAvg).length > 0 &&
          this.CheckUserPermission([1, 2, 3, 4, 12])
        ) {
          this.avgRawStats = [];
          Object.keys(stats).forEach(dataAvgKey => {
            if (
              dataAvgKey === "Cost" ||
              dataAvgKey === "NEW"
            ) {
              return;
            }
            let dataAvgKeyOrig = dataAvgKey;
            let avgKey = dataAvgKey;
            let valAvg;
            let showVal = 0;
            let lastPos = "total_in_time_frame";
            if (avgKey.includes("CC")) {
              avgKey = "CC";
              lastPos = "total_deposits_in_time_frame";
            }
            if (avgKey === "DP") {
              avgKey = "DEP";
            }
            if (statsAvg[this.selectedAvgRange].hasOwnProperty(avgKey)) {
              if (!this.selectedTierOption) {
                if (!this.selectedUser) {
                  valAvg =
                    statsAvg[this.selectedAvgRange][avgKey]["all_data"][
                      this.selectedLeadFilter
                    ][lastPos];
                } else {
                  if (avgKey === "REG" || avgKey === "NU") {
                    valAvg =
                      statsAvg[this.selectedAvgRange][avgKey]["all_data"][
                        this.selectedLeadFilter
                      ][lastPos];
                  } else {
                    valAvg =
                      statsAvg[this.selectedAvgRange][avgKey]["all_data"][
                        this.selectedLeadFilter
                      ].users[this.selectedUser].total;
                  }
                }
              } else {
                if (!this.selectedUser) {
                  valAvg =
                    statsAvg[this.selectedAvgRange][avgKey]["tiers"][
                      this.selectedTierOption
                    ][this.selectedLeadFilter][lastPos];
                } else {
                  if (avgKey === "REG" || avgKey === "NU") {
                    valAvg =
                      statsAvg[this.selectedAvgRange][avgKey]["all_data"][
                        this.selectedLeadFilter
                      ][lastPos];
                  } else {
                    valAvg =
                      statsAvg[this.selectedAvgRange][avgKey]["tiers"][
                        this.selectedTierOption
                      ][this.selectedLeadFilter].users[this.selectedUser].total;
                  }
                }
              }

              if (valAvg === 0) {
                if(dataAvgKeyOrig !== "REG"){
                  allAvgStats.push(valAvg - stats[dataAvgKeyOrig]);
                  this.avgRawStats.push(valAvg);
                }else{
                  regAvg = valAvg;
                }

                return;
              }
              showVal = valAvg;

              valAvg = valAvg - stats[dataAvgKeyOrig];
              if (valAvg) {
                if (`${valAvg}`.length > 2) {
                  let len = `${valAvg}`.length;

                  switch (len) {
                    case 3:
                      valAvg = (valAvg / 10).toFixed(1);
                      break;
                    case 4:
                      valAvg = (valAvg / 100).toFixed(2);
                      break;
                    case 5:
                      valAvg = (valAvg / 1000).toFixed(3);
                      break;
                  }
                  if(dataAvgKeyOrig !== "REG") {
                    allAvgStats.push(valAvg);
                    this.avgRawStats.push(showVal);
                  }else{
                    regAvg = showVal;
                  }
                  return;
                }
              } else {
                valAvg = 0;
                showVal = 0;
              }
              if(dataAvgKeyOrig !== "REG") {
                allAvgStats.push(valAvg);
                this.avgRawStats.push(showVal);
              }else{
                regAvg = showVal;
              }
            } else {
              if(dataAvgKeyOrig !== "REG") {
                allAvgStats.push(0);
                this.avgRawStats.push(0);
              }else{
                regAvg = 0;
              }
            }
          });
        }
      } catch (e) {}
      let dpAvgWeek;
      //weekends avg stats
      try {
        if (
          Object.keys(statsWeekendsAvg).length > 0 &&
          this.CheckUserPermission([1, 2, 3, 4, 12])
        ) {
          this.avgWeekendsRawStats = [];
          Object.keys(stats).forEach(dataAvgKey => {
            if (
              dataAvgKey === "Cost" ||
              dataAvgKey === "NEW"
            ) {
              return;
            }
            let dataAvgKeyOrig = dataAvgKey;
            let avgKey = dataAvgKey;
            let valAvg;
            let showVal = 0;
            let lastPos = "total_in_time_frame";
            if (avgKey.includes("CC")) {
              avgKey = "CC";
              lastPos = "total_deposits_in_time_frame";
            }
            if (avgKey === "DP") {
              avgKey = "DEP";
            }
            if (
              statsWeekendsAvg[this.selectedAvgRange].hasOwnProperty(avgKey)
            ) {
              if (!this.selectedTierOption) {
                if (!this.selectedUser) {
                  valAvg =
                    statsWeekendsAvg[this.selectedAvgRange][avgKey]["all_data"][
                      this.selectedLeadFilter
                    ][lastPos];
                } else {
                  if (avgKey === "REG" || avgKey === "NU") {
                    valAvg =
                      statsWeekendsAvg[this.selectedAvgRange][avgKey][
                        "all_data"
                      ][this.selectedLeadFilter][lastPos];
                  } else {
                    valAvg =
                      statsWeekendsAvg[this.selectedAvgRange][avgKey][
                        "all_data"
                      ][this.selectedLeadFilter].users[this.selectedUser].total;
                  }
                }
              } else {
                if (!this.selectedUser) {
                  valAvg =
                    statsWeekendsAvg[this.selectedAvgRange][avgKey]["tiers"][
                      this.selectedTierOption
                    ][this.selectedLeadFilter][lastPos];
                } else {
                  if (avgKey === "REG" || avgKey === "NU") {
                    valAvg =
                      statsWeekendsAvg[this.selectedAvgRange][avgKey][
                        "all_data"
                      ][this.selectedLeadFilter][lastPos];
                  } else {
                    valAvg =
                      statsWeekendsAvg[this.selectedAvgRange][avgKey]["tiers"][
                        this.selectedTierOption
                      ][this.selectedLeadFilter].users[this.selectedUser].total;
                  }
                }
              }
              regAvgWeek = valAvg;

            if(dataAvgKey === "REG"){
                regAvgWeek = valAvg;
              }
            if(avgKey === 'DEP'){
              dpAvgWeek = valAvg;
            }
              if (valAvg === 0) {
                if(dataAvgKey !== "REG"){
                  allWeekendsAvgStats.push(valAvg - stats[dataAvgKeyOrig]);
                  this.avgWeekendsRawStats.push(valAvg);
                }

                return;
              }
              showVal = valAvg;
              valAvg = valAvg - stats[dataAvgKeyOrig];
              if (valAvg) {
                if (`${valAvg}`.length > 2) {
                  let len = `${valAvg}`.length;

                  switch (len) {
                    case 3:
                      valAvg = (valAvg / 10).toFixed(1);
                      break;
                    case 4:
                      valAvg = (valAvg / 100).toFixed(2);
                      break;
                    case 5:
                      valAvg = (valAvg / 1000).toFixed(3);
                      break;
                  }
                  allWeekendsAvgStats.push(valAvg);
                  this.avgWeekendsRawStats.push(showVal);
                  return;
                }
              } else {
                valAvg = 0;
                showVal = 0;
              }

              allWeekendsAvgStats.push(valAvg);
              this.avgWeekendsRawStats.push(showVal);
            } else {
              allWeekendsAvgStats.push(0);
              this.avgWeekendsRawStats.push(0);
            }
          });
        }
      } catch (e) {}

      //cr stats
      let dpNumIdx = this.getKeyByValue(labels,keyDp);
      let dpNum = allStats[dpNumIdx];
      let dpAvg = allAvgStats[dpNumIdx];
      let crNum =  ((dpNum / regNum) *100).toFixed(0);
      let avgCr = ((dpAvg / regAvg) * 100).toFixed(0);
      let avgCrWeek = ((dpAvgWeek / regAvgWeek) * 100).toFixed(0);
      labels.push('CR')
      this.avgRawStats.push(avgCr);
      this.avgWeekendsRawStats.push(avgCrWeek)
      allStats.push(crNum)
      allAvgStats.push(avgCr)
      allWeekendsAvgStats.push(avgCrWeek)


      // let avgCrRaw = ((avgDpRaw / avgRegRaw) * 100).toFixed(0);
      // allStats.push(crNum);
      ////////////////
      let pointers = [];
      this.avgRawStats.map(point => {
        if (`${point}`.length > 2) {
          let len = `${point}`.length;

          switch (len) {
            case 3:
              point = (point / 10).toFixed(1);
              break;
            case 4:
              point = (point / 100).toFixed(2);
              break;
            case 5:
              point = (point / 1000).toFixed(3);
              break;
          }
        }
        pointers.push(point);
      });

      let bgColors = [];
      let brdColors = [];
      if (allStats.length > 10) {
        brdColors = [
          "rgba(124,124,124)",
          "rgba(124,124,124)",
          "rgba(124,124,124)",
          "rgba(92,90,105)",
          "rgba(18,19,19,1)",
          "rgba(0,77,64)",
          "rgba(128,250,0)",
          "rgba(171,155,12)",

          "rgba(0,139,0)",
          "rgba(153,200,172)",
          "rgba(250,129,0)",
          "rgba(244,81,30)",
          "rgba(70,172,220)",

          "rgba(17,68,188)",
          "rgba(189,58,255,0.8)",
          "rgba(18,19,19,1)",
          "rgba(128,250,0)",
        ];

        bgColors = [
          "rgba(124,124,124,0.7)",
          "rgba(124,124,124,0.7)",
          "rgba(124,124,124,0.7)",
          "rgba(92,90,105,0.7)",
          "rgba(18,19,19,1)",
          "rgba(0,77,64,0.7)",
          "rgba(5,243,5,0.7)",
          "rgba(250,225,5,0.7)",
          "rgba(128,250,0,0.7)",
          "rgba(153,200,172,0.7)",
          "rgba(250,129,0,0.7)",
          "rgba(244,81,30,0.7)",
          "rgba(70,172,220,0.7)",
          "rgba(17,68,188,0.7)",
          "rgba(189,58,255,0.7)",
          "rgba(18,19,19,1)",
          "rgba(5,243,5,0.7)",
        ];

        // if(allStats.includes('Cost')){
        // brdColors.splice(0, 0, "rgb(255,0,0)");
        // bgColors.splice(0, 0, "rgb(255,0,0,0.7)");
        // }
      } else {
        bgColors = [
          "rgba(0,77,64,0.7)",
          "rgba(128,250,0,0.7)",
          "rgba(153,200,172,0.7)",
          "rgba(250,129,0,0.7)",
          "rgba(244,81,30,0.7)",
          "rgba(70,172,220,0.7)",
          "rgba(17,68,188,0.7)",
          "rgba(189,58,255,0.7)",
          "rgba(18,19,19,0.7)"
        ];

        brdColors = [
          "rgba(0,77,64)",
          "rgba(128,250,0)",
          "rgba(153,200,172)",
          "rgba(250,129,0)",
          "rgba(244,81,30)",
          "rgba(70,172,220)",
          "rgba(17,68,188)",
          "rgba(189,58,255,0.8)",
          "rgba(18,19,19,1)"
        ];
      }

      const data = {
        labels: labels,
        datasets: [
          {
            type: "bar",
            label: "Count",
            data: allStats, //onlineTrans,
            fill: true,
            borderColor: brdColors,
            backgroundColor: bgColors,
            borderWidth: 0.5,
            maxBarThickness: 40,
            categoryPercentage: 1.0,
            barPercentage: 0.5
          },
          {
            type: "bar",
            label: "AVG",
            data: allAvgStats, //onlineTrans,
            fill: true,
            borderColor: brdColors,
            backgroundColor: "rgb(255,255,255)",
            borderWidth: 0.5,
            maxBarThickness: 40,
            categoryPercentage: 1.0,
            barPercentage: 0.5,
            minBarLength: function(value) {
              if (value.dataset.data[value.dataIndex] > 0) {
                return 15;
              } else {
                return 0;
              }
            }
          },
          {
            type: "line",
            label: "Live",
            fill: false,
            borderColor: "rgb(162,162,162)", //"rgba(186,231,85,0.9)",
            borderWith: 0.5,
            backgroundColor: "#e755ba",
            pointBackgroundColor: brdColors,
            pointBorderColor: "rgb(162,162,162)",
            pointHoverBackgroundColor: "rgb(162,162,162)",
            pointHoverBorderColor: "rgb(162,162,162)",
            data: pointers,
            hidden: true
          }
        ]
      };

      if (this.mainChartTabBuild) {
        this.mainChartTabBuild.destroy();
      }

      const ctx = document.getElementById(canvasId);
      this.mainChartTabBuild = new Chart(ctx, {
        height: 260,
        type: chartOpt.type,
        data: data,
        options: opt,
        plugins: [ChartDataLabels]
      });

      ctx.onclick = evt => {
        this.clickLiveChart(this.mainChartTabBuild, evt, labels);
      };
    },

    clickLiveChart(myChart, evt, labelName) {
      const activePoints = myChart.getElementsAtEvent(evt);
      if (activePoints[0]) {
        const idx = activePoints[0]["_index"];
        let filter = labelName[idx];
        let preset = null;
        this.$store.commit("clients/setGeneralChartFilter", {
          filter: filter,
          user: this.selectedUser,
          date: [
            moment(this.statsDate[0]).format("YYYY-MM-DD"),
            moment(this.statsDate[1]).format("YYYY-MM-DD")
          ],
          preset: preset,
          tier: this.selectedTierOption,
          lead_filter: this.selectedLeadFilter
        });
      }
    },
    notAfterToday(date) {
      return date > moment().toDate();
    },
    getClasses(date) {
      if (
        moment(this.statsDate).format("YYYY-MM-DD") ===
        moment(date).format("YYYY-MM-DD")
      ) {
        return "highlight";
      }
      return "";
    },
    async getExpendData(label) {
      this.loaderIcon = true;
      const filter = label;

      let queryObj = {
        stats_date_at: moment(this.statsDate[0]).format("YYYY-MM-DD"),
        stats_date_to: moment(this.statsDate[1]).format("YYYY-MM-DD")
      };
      if (this.selectedUser) {
        queryObj = { ...queryObj, user_id: this.selectedUser };
      }
      if (this.selectedTierOption) {
        queryObj = { ...queryObj, country_tiers: [this.selectedTierOption] };
      }
      queryObj = { ...queryObj, special_req: 1 };
      await apiClientCreator(`client/stats/today_chart/ext/${filter}`)
        .get("", { params: queryObj })
        .then(res => {
          this.expendedChartData[filter] = res.data;
          // this.loaderIcon = false;
        })
        .catch(err => {
          this.loaderIcon = false;
        });
      this.loaderIcon = false;
    }
  }
};
</script>

<style scoped>
/*@import "../../../../../../public/css/datePicker.css";  // TODO: Moved to CDN*/
html * {
  text-transform: capitalize;
}
.body-div {
  /*padding: 5px 5px 1px 5px;*/
  /*padding-top: 5px;*/
  overflow-y: hidden;
  overflow-x: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 2px solid #a6a6a673;
  border-radius: 12px;
  padding-top: 12px;
  padding-right: 12px;
  padding-bottom: 12px;
  padding-left: 12px;
}
.main-chart {
  min-width: 100%;
  height: 100%;
  margin: auto;
  background: white;
  border-radius: 3px;
  /*padding: 5px;*/
  position: relative;
}
.last-update-date {
  position: absolute;
  font-size: 12px;
  z-index: 1;
  right: 1px;
  top: -5px;
}
.refresh-button {
  position: absolute;
  font-size: 10px;
  z-index: 1;
  right: 100px;
  top: -5px;
  height: 18px;
}
.report-calendar {
  /*margin-top: 13px;*/
}
.selection-user-bar {
  width: 100%;
  display: flex;
  justify-content: space-between;
  /*height: 30px;*/
  border-radius: 0px;
}
.dropdown-menu.ul-users {
  font-size: 14px;
  overflow-y: scroll;
  max-height: 167px;
  border-radius: 0px;
  width: 100%;
  cursor: pointer;
  border: none;
  min-width: 200px;
}
.dropdown-menu.ul-tiers {
  font-size: 11px;
  max-height: 225px;
  border-radius: 0px;
  width: 100%;
  cursor: pointer;
  border: none;
  min-width: 73px;
}
.dropdown-menu.ul-tiers > li > a {
  padding: 3px 12px;
}
.dropdown-menu {
  border-radius: 0;
}
.activedrop {
  background-color: #efefef;
}
/*.tiers-btns{*/
/*  flex: 1;*/
/*}*/
.tiers-btn {
  border: 0px;
  border-radius: 0px;
  width: 100%;
  font-size: 10px;
  height: 15px;
}
.tiers-btn p {
  margin-bottom: 0px;
}
.tiers-btn:focus {
  outline: none;
}
.tiers-btn.active {
  background-color: #44a2d2;
  color: #fff;
}
.selecting-options {
  display: flex;
}
.loader-icon {
  display: flex;
  justify-content: center;
}
.loader-icon > span > img {
  width: 15px;
}
canvas {
  height: 70vh;
  /*width: 100vw;*/
  display: block;
}
</style>
